<script>
export default {
  name: 'TicketItem',
  props: {
    ticket: { type: Object, required: true },
  },
  computed: {
    statusLabel() {
      return this.ticket.paid ? 'Bezahlt' : 'Ausstehend'
    },
    statusClass() {
      return this.ticket.paid ? 'bg-success' : 'bg-warning text-dark'
    },
  },
  methods: {
    fmt(iso) {
      if (!iso) return ''
      const d = new Date(iso)
      return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },
  }
}
</script>

<template>
  <div class="card mb-2">
    <div class="card-header d-flex align-items-center">
      <b class="flex-fill">{{ ticket.product_name }}</b>
      <span class="badge" :class="statusClass">{{ statusLabel }}</span>
    </div>

    <div class="card-body d-flex align-items-center py-2">
      <i class="bi bi-ticket-detailed fs-2 me-3 text-primary"></i>
      <div class="flex-fill">
        <div><b>{{ ticket.event_name }}</b> <small class="text-muted">({{ ticket.event_short_name }})</small></div>
        <div class="text-muted small">
          <span v-if="ticket.timestamp"><i class="bi bi-calendar me-1"></i>{{ fmt(ticket.timestamp) }}</span>
          <span class="ms-2"><i class="bi bi-upc me-1"></i>{{ ticket.ticket_id }}</span>
        </div>
      </div>
    </div>

    <div v-if="ticket.pdf_url || ticket.eticket_url" class="card-footer d-flex gap-1">
      <a v-if="ticket.pdf_url" :href="ticket.pdf_url" target="_blank" class="btn btn-sm btn-outline-primary">
        <i class="bi bi-download me-1"></i>PDF
      </a>
      <a v-if="ticket.eticket_url" :href="ticket.eticket_url" target="_blank" class="btn btn-sm btn-outline-secondary">
        <i class="bi bi-phone me-1"></i>Wallet
      </a>
    </div>
  </div>
</template>
